module.exports = __webpack_public_path__ + "img/bg9.3f51d318.jpg";